import { debounce } from 'lodash'
import { useCallback, useRef, useState } from 'react'
import { useResizeObserver } from './useResizeObserver'

// eslint-disable-next-line import/prefer-default-export
export const useOverflowObserver = () => {
  const targetRef = useRef<HTMLElement | null>(null)
  const [isOverflowX, setIsOverflowX] = useState(false)
  const [isOverflowY, setIsOverflowY] = useState(false)

  const observeOverflow = () => {
    if (!targetRef.current) return

    const container = targetRef.current
    const { scrollWidth, clientWidth, scrollHeight, clientHeight } = container
    setIsOverflowX(scrollWidth > clientWidth)
    setIsOverflowY(scrollHeight > clientHeight)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useResizeObserver(targetRef, useCallback(debounce(observeOverflow, 10), []))

  return { targetRef, isOverflowX, isOverflowY }
}
